import MinorHome from './MinorHome'
export default MinorHome
